import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Comment } from '../entities/comment';

@Injectable({
  providedIn: 'root'
})
export class CommentService {

  constructor(private http: HttpClient) {}

  private baseUrl = environment.apiUrl + '/api/comment/';
  basic: string | string[];

  addComment(comment: Comment): Observable<Comment> {
    return this.http.post<Comment>(this.baseUrl, comment);
  }

  getProposalComments(proposalId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}proposals/${ proposalId }`, { responseType: 'text' });
  }
}
